<template>
  <div id="login">
    <div class="container form-signin">
      <!-- 帳密 -->
      <form>
        <v-label class="pd-4" />
        <v-label for="UserId" class="sr-only" LabText="帳號" />
        <input
          class="form-control"
          type="text"
          v-model="LoginData.UserId"
          placeholder="請輸入校務行政系統帳號"
          required
          autofocus
        />
        <v-label for="password" class="sr-only" LabText="密碼" />
        <input
          class="form-control"
          type="password"
          v-model="LoginData.UserPasswd"
          placeholder="請輸入密碼"
          @keyup.enter="clickEnter"
          required
          autocomplete
        />
      </form>
      <!-- 記住我 -->
      <div class="checkbox mb-3">
        <input
          slot="small"
          type="checkbox"
          class="mt-1"
          v-model="checked"
          :true-value="'1'"
          :false-value="'2'"
        />
        記住我
      </div>
      <!-- 登入鈕 -->
      <v-button
        btn-text="登入"
        btn-type="primary"
        btn-size="lg"
        btn-block="true"
        @click.native="PostLogin"
      />
    </div>
    <!-- 選擇帳號單位Modal -->
    <v-modal id="ShowDeptList">
      <div slot="header">
        請選擇登入的單位
      </div>
      <div slot="body">
        <b-table
          ref="selectableTable"
          responsive="sm"
          selectable
          selected-variant="active"
          :select-mode="selectMode"
          :items="items"
          :fields="fields"
          @row-selected="onRowSelected"
        >
          <template v-slot:cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">
                &check;
              </span>
              <span class="sr-only">
                選取
              </span>
            </template>
            <template v-else>
              <span aria-hidden="true">
                &nbsp;
              </span>
              <span class="sr-only">
                取消
              </span>
            </template>
          </template>
          <!-- 管理員 -->
          <template v-slot:cell(DeptDesc)="data">
            <span v-if="data.item.DeptPrivilege === 11">
              {{ data.item.DeptDesc + '(管理員)' }}
            </span>
            <span v-else>
              {{ data.item.DeptDesc }}
            </span>
          </template>
        </b-table>
      </div>
      <div slot="footer">
        <v-button class="mr-2" btn-text="取消" btn-type="secondary" data-dismiss="modal" />
        <v-button btn-text="登入" btn-type="primary" @click.native="ManyDep" />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { apiAdminAccountLogin } from '../../Api/api'
import vModal from '@/components/Features/ModalFloot'
import vLabel from '@/components/Features/Label'
import $ from 'jquery'
import md5 from 'js-md5'
export default {
  name: 'login',
  components: {
    vLabel,
    vModal
  },
  data () {
    return {
      items: [], // 多部門資料
      fields: [
        { key: 'selected', label: '選取', thClass: 'table-th' },
        { key: 'DeptDesc', label: '單位', thClass: 'table-th' }
      ],
      selectMode: 'single', // 單選
      selected: [], // 選部門
      LoginData: {
        // 登入API資料
        APIVer: '0',
        ClientIP: '',
        UserType: 3, // 帳號權限
        UserId: localStorage.getItem('M_KeepUserId') ? localStorage.getItem('M_KeepUserId') : '',
        UserPasswd: '',
        Timeout: 200 // 帳號停留時間
      },
      DeptList: {}, // 多部門
      UserData: {}, // Nav資料
      Identity: {}, // API預設資料
      BackendPrivilege: '', // 帳號權限
      checked: localStorage.getItem('M_checked') ? localStorage.getItem('M_checked') : '2'
    }
  },
  methods: {
    clickEnter () {
      this.PostLogin()
    },
    PostLogin () {
      // (1) 登入 B_API 003
      // 防呆&定義資料
      var vm = this
      if (vm.LoginData.UserId === '' || vm.LoginData.UserPasswd === '') {
        vm.$bus.$emit('Modals', '帳號或密碼不得為空')
        $('#CheckError').modal('show')
        return false
      }
      $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function (data) {
        vm.LoginData.ClientIP = data.ip
      })

      // 記住我判斷
      if (vm.checked === '1') {
        // true
        localStorage.setItem('M_KeepUserId', vm.LoginData.UserId)
        localStorage.setItem('M_checked', '1')
      } else {
        // false
        localStorage.removeItem('M_KeepUserId')
        localStorage.setItem('M_checked', '2')
      }
      localStorage.setItem('Version', window.g.Version) // 記住版本號

      // 呼叫API
      apiAdminAccountLogin(vm.LoginData).then(res => {
        if (res !== undefined) {
          // 帳號判斷
          const DeptListData = res.DeptList.length
          sessionStorage.setItem('LonginData', JSON.stringify(res))
          sessionStorage.setItem('ManyDep', JSON.stringify(res.DeptList))
          const Userdata = {}
          Userdata.Address = res.Address
          Userdata.Email = res.Email
          Userdata.Telephone = res.Telephone
          Userdata.UserId = res.UserId
          Userdata.UserName = res.UserName
          sessionStorage.setItem('Userdata', JSON.stringify(Userdata))
          // 帳號單位數量
          if (DeptListData === 1) {
            vm.Privileges(res.DeptList[0])
            // 多單位選擇
          } else if (DeptListData >= 2) {
            vm.items = res.DeptList
            $('#ShowDeptList').modal('show')
          } else {
            sessionStorage.removeItem('LonginData')
            sessionStorage.removeItem('ManyDep')
            vm.Identity.APIVer = '0'
            vm.Identity.ClientIP = ''
            vm.Identity.UserId = res.UserId
            vm.Identity.Token = res.Token
            sessionStorage.setItem('Identity', JSON.stringify(vm.Identity))
            vm.$bus.$emit('Modals', '帳號權限未申請')
            $('#CheckError').modal('show')
            // 導向 申請權限表
            vm.$router.push({
              name: 'Admin_Access_Request',
              params: {
                id: vm.LoginData.UserId,
                type: 'Application',
                again: md5('false')
              }
            })
          }
        }
      })
    },
    ManyDep () {
      // (1-2) 多單位帳號，選擇單位
      $('#ShowDeptList').modal('hide')
      this.Privileges(this.selected[0])
    },
    Privileges (data) {
      // (2) 已確認部門單位，判斷帳號狀態、權限
      var vm = this
      var Privilege = data.DeptPrivilege
      var admins
      vm.BackendPrivilege = md5('無權限')
      sessionStorage.setItem('BackendPrivilege', vm.BackendPrivilege)
      if (Privilege === 0) {
        sessionStorage.removeItem('LonginData')
        vm.$bus.$emit('Modals', '帳號申請未通過，請洽詢管理員。')
        $('#CheckError').modal('show')
        return false
      } else if (Privilege === 1 || Privilege === 2) {
        sessionStorage.removeItem('LonginData')
        sessionStorage.removeItem('ManyDep')
        sessionStorage.removeItem('BackendPrivilege')
        sessionStorage.setItem('Department', JSON.stringify(data))
        vm.$bus.$emit('Modals', '此帳號申請權限中，請等待管理員開通。')
        $('#CheckError').modal('show')
        // 導向 申請權限表
        vm.$router.push({
          name: 'Admin_Access_Request',
          params: {
            id: vm.LoginData.UserId,
            type: 'Application',
            again: md5('true')
          }
        })
        return false
      } else if (Privilege === 11 || Privilege === 12) {
        vm.BackendPrivilege = md5('有權限')
        if (Privilege === 11) {
          admins = md5('管理者')
          vm.UserData.Privilege = '管理者'
        } else {
          admins = md5('業務')
          vm.UserData.Privilege = '業務單位'
        }
        sessionStorage.setItem('Backend', admins)
        sessionStorage.setItem('BackendPrivilege', vm.BackendPrivilege)
        vm.GoToLogin(data)
      } else if (Privilege === 255) {
        sessionStorage.removeItem('LonginData')
        vm.$bus.$emit('Modals', '帳號權限未申請')
        $('#CheckError').modal('show')
        // 導向 申請權限表
        vm.$router.push({
          name: 'Admin_Access_Request',
          params: {
            id: 'wenwend6',
            type: 'Application',
            again: md5('false')
          }
        })
      } else {
        // 超出 後台使用權限 參數
        sessionStorage.removeItem('LonginData')
        vm.$bus.$emit('Modals', '帳號異常，請通知管理人員。')
        $('#CheckError').modal('show')
      }
    },
    GoToLogin (data) {
      // (3) 紀錄登入資訊
      var vm = this
      const LonginData = JSON.parse(sessionStorage.getItem('LonginData'))
      // Nav資料
      vm.UserData.UserId = LonginData.UserId
      vm.UserData.UserName = LonginData.UserName
      vm.UserData.DeptId = data.DeptId
      vm.UserData.UserManyDep = data.DeptDesc
      sessionStorage.setItem('UserData', JSON.stringify(vm.UserData))
      // API資料
      vm.Identity.APIVer = '0'
      vm.Identity.ClientIP = vm.LoginData.ClientIP
      vm.Identity.UserId = LonginData.UserId
      vm.Identity.Token = LonginData.Token
      sessionStorage.setItem('Identity', JSON.stringify(vm.Identity))
      // 變動 後台Menu
      sessionStorage.setItem('M_Menu', 'true')
      sessionStorage.removeItem('LonginData')
      vm.$bus.$emit('LoginUser', 'true')
      vm.$bus.$emit('LoginMenu', 'true')
      vm.$bus.$emit('messsage:push', '登入成功', 'primary')
      vm.$router.push({ name: 'Admin_Payment_review' })
      // window.location.reload(true)
    },
    onRowSelected (items) {
      // 業務多單位選項
      this.selected = items
    }
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  background-color: #f1f1f1;
}
#login {
  display: -webkit-box;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
  display: flex;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 1rem;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type='email'] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type='password'] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.long-test {
  color: #000000c2;
  background-color: #f1f1f1;
  display: -webkit-box;
  font-size: medium;
}
</style>
